import React from "react";
import "./StatCard.css";

/**
 * Composant StatCard réutilisable pour afficher des statistiques dans un format de carte
 * 
 * @param {string} type - Type de statistique pour appliquer les styles de couleur
 * @param {string} label - Texte du label affiché
 * @param {number|string} value - Valeur à afficher
 * @param {string|ReactNode} icon - Emoji ou composant d'icône (optionnel)
 * @param {boolean} showIcon - Afficher ou masquer l'icône (optionnel)
 * @param {string} variant - Variante d'affichage: "default" | "dashboard" | "pharmacie" (optionnel)
 * @param {object} actionButton - Configuration du bouton d'action {label, onClick} (optionnel, pour variant="pharmacie")
 * @param {string} className - Classes CSS supplémentaires (optionnel)
 */
export default function StatCard({
  type,
  label,
  value,
  icon,
  showIcon,
  variant = "default",
  actionButton,
  className = "",
}) {
  // Mapping des emojis par défaut (uniquement pour variant="default")
  const defaultIcons = {
    naissance: "🐑",
    achat: "💰",
    vente: "📦",
    mortalite: "☠️",
    zakat: "🕌",
  };

  // Déterminer si on doit afficher l'icône
  const shouldShowIcon = showIcon !== undefined 
    ? showIcon 
    : variant === "default" || variant === "pharmacie";

  // Déterminer l'icône à afficher
  const displayIcon = icon !== undefined 
    ? icon 
    : (variant === "default" && defaultIcons[type] ? defaultIcons[type] : null);

  // Classes CSS
  const cardClasses = [
    "stat-card",
    `stat-${type}`,
    `stat-card-${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  // Rendu selon la variante
  if (variant === "pharmacie") {
    return (
      <div className={cardClasses}>
        {shouldShowIcon && displayIcon && (
          <div className="stat-icon stat-icon-pharmacie">{displayIcon}</div>
        )}
        <div className="stat-content">
          <p className="stat-label stat-label-pharmacie">{label}</p>
          <p className="stat-value stat-value-pharmacie">{value}</p>
        </div>
        {actionButton && (
          <button
            className="stat-card-action"
            onClick={actionButton.onClick}
          >
            {actionButton.label}
          </button>
        )}
      </div>
    );
  }

  if (variant === "dashboard") {
    return (
      <div className={cardClasses}>
        <p className="stat-label stat-label-dashboard">{label}</p>
        <p className="stat-value stat-value-dashboard">
          <strong>{value}</strong>
        </p>
      </div>
    );
  }

  // Variant "default" (Evenements)
  return (
    <div className={cardClasses}>
      {shouldShowIcon && displayIcon && (
        <span className="stat-icon stat-icon-default">{displayIcon}</span>
      )}
      <span className="stat-label stat-label-default">{label}</span>
      <span className="stat-value stat-value-default">{value}</span>
    </div>
  );
}

